/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SitemapDotxmlRouteImport } from './routes/sitemap[.]xml'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CollectionsRouteImport } from './routes/collections'
import { Route as CartRouteImport } from './routes/cart'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AccountRouteImport } from './routes/account'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ShopIndexRouteImport } from './routes/shop.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AccountIndexRouteImport } from './routes/account.index'
import { Route as ShopProductIdRouteImport } from './routes/shop.$productId'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminOrdersRouteImport } from './routes/admin.orders'
import { Route as AdminCouponsRouteImport } from './routes/admin.coupons'
import { Route as AdminCollectionsRouteImport } from './routes/admin.collections'
import { Route as AdminCategoriesRouteImport } from './routes/admin.categories'
import { Route as AccountWishlistRouteImport } from './routes/account.wishlist'
import { Route as AccountProfileRouteImport } from './routes/account.profile'
import { Route as AccountOrdersRouteImport } from './routes/account.orders'
import { Route as AccountAddressesRouteImport } from './routes/account.addresses'

const SitemapDotxmlRoute = SitemapDotxmlRouteImport.update({
  id: '/sitemap.xml',
  path: '/sitemap.xml',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const CollectionsRoute = CollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => rootRouteImport,
} as any)
const CartRoute = CartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ShopIndexRoute = ShopIndexRouteImport.update({
  id: '/shop/',
  path: '/shop/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AccountIndexRoute = AccountIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AccountRoute,
} as any)
const ShopProductIdRoute = ShopProductIdRouteImport.update({
  id: '/shop/$productId',
  path: '/shop/$productId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProductsRoute = AdminProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrdersRoute = AdminOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCouponsRoute = AdminCouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCollectionsRoute = AdminCollectionsRouteImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => AdminRoute,
} as any)
const AccountWishlistRoute = AccountWishlistRouteImport.update({
  id: '/wishlist',
  path: '/wishlist',
  getParentRoute: () => AccountRoute,
} as any)
const AccountProfileRoute = AccountProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AccountRoute,
} as any)
const AccountOrdersRoute = AccountOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AccountRoute,
} as any)
const AccountAddressesRoute = AccountAddressesRouteImport.update({
  id: '/addresses',
  path: '/addresses',
  getParentRoute: () => AccountRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRoute
  '/cart': typeof CartRoute
  '/collections': typeof CollectionsRoute
  '/contact': typeof ContactRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/account/addresses': typeof AccountAddressesRoute
  '/account/orders': typeof AccountOrdersRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/wishlist': typeof AccountWishlistRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/collections': typeof AdminCollectionsRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/shop/$productId': typeof ShopProductIdRoute
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/shop/': typeof ShopIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/auth': typeof AuthRoute
  '/cart': typeof CartRoute
  '/collections': typeof CollectionsRoute
  '/contact': typeof ContactRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/account/addresses': typeof AccountAddressesRoute
  '/account/orders': typeof AccountOrdersRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/wishlist': typeof AccountWishlistRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/collections': typeof AdminCollectionsRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/shop/$productId': typeof ShopProductIdRoute
  '/account': typeof AccountIndexRoute
  '/admin': typeof AdminIndexRoute
  '/shop': typeof ShopIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/account': typeof AccountRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRoute
  '/cart': typeof CartRoute
  '/collections': typeof CollectionsRoute
  '/contact': typeof ContactRoute
  '/sitemap.xml': typeof SitemapDotxmlRoute
  '/account/addresses': typeof AccountAddressesRoute
  '/account/orders': typeof AccountOrdersRoute
  '/account/profile': typeof AccountProfileRoute
  '/account/wishlist': typeof AccountWishlistRoute
  '/admin/categories': typeof AdminCategoriesRoute
  '/admin/collections': typeof AdminCollectionsRoute
  '/admin/coupons': typeof AdminCouponsRoute
  '/admin/orders': typeof AdminOrdersRoute
  '/admin/products': typeof AdminProductsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/shop/$productId': typeof ShopProductIdRoute
  '/account/': typeof AccountIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/shop/': typeof ShopIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/account'
    | '/admin'
    | '/auth'
    | '/cart'
    | '/collections'
    | '/contact'
    | '/sitemap.xml'
    | '/account/addresses'
    | '/account/orders'
    | '/account/profile'
    | '/account/wishlist'
    | '/admin/categories'
    | '/admin/collections'
    | '/admin/coupons'
    | '/admin/orders'
    | '/admin/products'
    | '/admin/settings'
    | '/admin/users'
    | '/shop/$productId'
    | '/account/'
    | '/admin/'
    | '/shop/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/auth'
    | '/cart'
    | '/collections'
    | '/contact'
    | '/sitemap.xml'
    | '/account/addresses'
    | '/account/orders'
    | '/account/profile'
    | '/account/wishlist'
    | '/admin/categories'
    | '/admin/collections'
    | '/admin/coupons'
    | '/admin/orders'
    | '/admin/products'
    | '/admin/settings'
    | '/admin/users'
    | '/shop/$productId'
    | '/account'
    | '/admin'
    | '/shop'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/account'
    | '/admin'
    | '/auth'
    | '/cart'
    | '/collections'
    | '/contact'
    | '/sitemap.xml'
    | '/account/addresses'
    | '/account/orders'
    | '/account/profile'
    | '/account/wishlist'
    | '/admin/categories'
    | '/admin/collections'
    | '/admin/coupons'
    | '/admin/orders'
    | '/admin/products'
    | '/admin/settings'
    | '/admin/users'
    | '/shop/$productId'
    | '/account/'
    | '/admin/'
    | '/shop/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AccountRoute: typeof AccountRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  AuthRoute: typeof AuthRoute
  CartRoute: typeof CartRoute
  CollectionsRoute: typeof CollectionsRoute
  ContactRoute: typeof ContactRoute
  SitemapDotxmlRoute: typeof SitemapDotxmlRoute
  ShopProductIdRoute: typeof ShopProductIdRoute
  ShopIndexRoute: typeof ShopIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sitemap.xml': {
      id: '/sitemap.xml'
      path: '/sitemap.xml'
      fullPath: '/sitemap.xml'
      preLoaderRoute: typeof SitemapDotxmlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections': {
      id: '/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof CollectionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cart': {
      id: '/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof CartRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shop/': {
      id: '/shop/'
      path: '/shop'
      fullPath: '/shop/'
      preLoaderRoute: typeof ShopIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/': {
      id: '/account/'
      path: '/'
      fullPath: '/account/'
      preLoaderRoute: typeof AccountIndexRouteImport
      parentRoute: typeof AccountRoute
    }
    '/shop/$productId': {
      id: '/shop/$productId'
      path: '/shop/$productId'
      fullPath: '/shop/$productId'
      preLoaderRoute: typeof ShopProductIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/products': {
      id: '/admin/products'
      path: '/products'
      fullPath: '/admin/products'
      preLoaderRoute: typeof AdminProductsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orders': {
      id: '/admin/orders'
      path: '/orders'
      fullPath: '/admin/orders'
      preLoaderRoute: typeof AdminOrdersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/coupons': {
      id: '/admin/coupons'
      path: '/coupons'
      fullPath: '/admin/coupons'
      preLoaderRoute: typeof AdminCouponsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/collections': {
      id: '/admin/collections'
      path: '/collections'
      fullPath: '/admin/collections'
      preLoaderRoute: typeof AdminCollectionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/categories': {
      id: '/admin/categories'
      path: '/categories'
      fullPath: '/admin/categories'
      preLoaderRoute: typeof AdminCategoriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/account/wishlist': {
      id: '/account/wishlist'
      path: '/wishlist'
      fullPath: '/account/wishlist'
      preLoaderRoute: typeof AccountWishlistRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/profile': {
      id: '/account/profile'
      path: '/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof AccountProfileRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/orders': {
      id: '/account/orders'
      path: '/orders'
      fullPath: '/account/orders'
      preLoaderRoute: typeof AccountOrdersRouteImport
      parentRoute: typeof AccountRoute
    }
    '/account/addresses': {
      id: '/account/addresses'
      path: '/addresses'
      fullPath: '/account/addresses'
      preLoaderRoute: typeof AccountAddressesRouteImport
      parentRoute: typeof AccountRoute
    }
  }
}

interface AccountRouteChildren {
  AccountAddressesRoute: typeof AccountAddressesRoute
  AccountOrdersRoute: typeof AccountOrdersRoute
  AccountProfileRoute: typeof AccountProfileRoute
  AccountWishlistRoute: typeof AccountWishlistRoute
  AccountIndexRoute: typeof AccountIndexRoute
}

const AccountRouteChildren: AccountRouteChildren = {
  AccountAddressesRoute: AccountAddressesRoute,
  AccountOrdersRoute: AccountOrdersRoute,
  AccountProfileRoute: AccountProfileRoute,
  AccountWishlistRoute: AccountWishlistRoute,
  AccountIndexRoute: AccountIndexRoute,
}

const AccountRouteWithChildren =
  AccountRoute._addFileChildren(AccountRouteChildren)

interface AdminRouteChildren {
  AdminCategoriesRoute: typeof AdminCategoriesRoute
  AdminCollectionsRoute: typeof AdminCollectionsRoute
  AdminCouponsRoute: typeof AdminCouponsRoute
  AdminOrdersRoute: typeof AdminOrdersRoute
  AdminProductsRoute: typeof AdminProductsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminCategoriesRoute: AdminCategoriesRoute,
  AdminCollectionsRoute: AdminCollectionsRoute,
  AdminCouponsRoute: AdminCouponsRoute,
  AdminOrdersRoute: AdminOrdersRoute,
  AdminProductsRoute: AdminProductsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AccountRoute: AccountRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  AuthRoute: AuthRoute,
  CartRoute: CartRoute,
  CollectionsRoute: CollectionsRoute,
  ContactRoute: ContactRoute,
  SitemapDotxmlRoute: SitemapDotxmlRoute,
  ShopProductIdRoute: ShopProductIdRoute,
  ShopIndexRoute: ShopIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
